export type RemValue = `${number}rem`;
export type EmValue = `${number}em`;
export type PxValue = `${number}px`;
export type CssValue = EmValue | RemValue | PxValue;

export enum SortingOrder {
	ASC = 'asc',
	DESC = 'desc',
}
